import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { BaseService } from 'src/app/shared/services/base.service';
import { AppointmentInfoReponseModel } from 'src/app/shared/models/response/appointment/appointment-info-reponse-model';
import { FacilitySearchRequestModel } from 'src/app/shared/models/request/facility-search-request';
import { FacilitySearchResponseModel } from 'src/app/shared/models/response/appointment/facility-search-response';
import { AppointmentRequestModel } from 'src/app/shared/models/request/appointment-request';
import { FacilityTimeSlotRequest } from 'src/app/shared/models/request/facility-slots-request';
import { AppointmentCancelRequest } from 'src/app/shared/models/request/appointment-cancel-request';
import { AppointmentFacilityResponseModel } from 'src/app/shared/models/response/appointment/appointment-facility-response-model';
import { WebStorageService } from '../../shared/services/web-storage.service';
import { SettingsResponseModel } from 'src/app/shared/models/response/settings-response';
import { CancelFeesInfo } from 'src/app/interfaces/cancel-fees-info';
import { PaymentTransaction } from 'src/app/interfaces/recent-patient-transaction';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PatientService extends BaseService {
  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  isGroupAppointment: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  isGroupAppointment$ = this.isGroupAppointment.asObservable();

  public setIsGroupAppointment(value: boolean) {
    this.isGroupAppointment.next(value);
  }

  searchFacilityByPatient(facilitysearchrequestModel: FacilitySearchRequestModel, isRefresh: boolean) {
    var url = 'Patient/SearchClinicsForPatient';
    if (facilitysearchrequestModel.crmSalesOrderId) {
      url = url + '?CrmSalesorderId=' + facilitysearchrequestModel.crmSalesOrderId;
    }
    if (facilitysearchrequestModel.crmPatientId) {
      url = url + '&CrmPatientId=' + facilitysearchrequestModel.crmPatientId;
    }

    if (facilitysearchrequestModel.crmPatientZipCode) {
      url = url + '&CrmPatientZipCode=' + facilitysearchrequestModel.crmPatientZipCode;
    }
    if (facilitysearchrequestModel.crmState) {
      url = url + '&CrmState=' + facilitysearchrequestModel.crmState;
    }
    if (facilitysearchrequestModel.radius) {
      url = url + '&Radius=' + facilitysearchrequestModel.radius;
    }
    if (facilitysearchrequestModel.schAppointmentDateStartTimeString) {
      url = url + '&SchAppointmentDateStartTime=' + facilitysearchrequestModel.schAppointmentDateStartTimeString;
    }
    if (facilitysearchrequestModel.schAppointmentDateEndTimeString) {
      url = url + '&SchAppointmentDateEndTime=' + facilitysearchrequestModel.schAppointmentDateEndTimeString;
    }

    if (facilitysearchrequestModel.isBillingAddress) {
      url = url + '&isBillingAddress=' + facilitysearchrequestModel.isBillingAddress;
    }
    if (facilitysearchrequestModel.searchText) {
      url = url + '&searchText=' + facilitysearchrequestModel.searchText;
    }
    if (facilitysearchrequestModel.facilityZipCode) {
      url = url + '&facilityZipCode=' + facilitysearchrequestModel.facilityZipCode;
    }
    if (facilitysearchrequestModel.patientTimeZone) {
      url = url + '&patientTimeZone=' + facilitysearchrequestModel.patientTimeZone;
    }
    url = url + '&isAppointment=' + facilitysearchrequestModel.isAppointment;
    if (isRefresh) {
      url = url + '&rnd=' + Math.random().toString();
    }
    return this.get<ResultOfT<FacilitySearchResponseModel[]>>(url).pipe(
      map((result) => {
        return result;
      })
    );
  }

  getMultiFacilityTimeSlots(timeslotRequest: FacilityTimeSlotRequest[]) {
    return this.post<ResultOfT<FacilitySearchResponseModel[]>>('Patient/GetMultiFacilityTimeSlotsByPatient/', timeslotRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  GetTimeSlotsAvailabilityByTherapist(timeslotRequest: FacilityTimeSlotRequest) {
    return this.post<ResultOfT<FacilitySearchResponseModel>>('Patient/GetTimeSlotsAvailabilityByTherapistForPatient/', timeslotRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  getTherapistFacilityTypeDetails(timeslotRequest: FacilityTimeSlotRequest) {
    return this.post<ResultOfT<FacilitySearchResponseModel>>('Patient/GetTherapistFacilityTypeDetails/', timeslotRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  GetRemoteFacilityTimeSlotsByPatient(timeslotRequest: FacilityTimeSlotRequest) {
    return this.post<ResultOfT<FacilitySearchResponseModel>>('Patient/GetRemoteFacilityTimeSlotsByPatient/', timeslotRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  GetRemoteSelfGuidedTimeSlotsByPatient(timeslotRequest: FacilityTimeSlotRequest) {
    return this.post<ResultOfT<FacilitySearchResponseModel>>('Patient/GetRemoteSelfGuidedTimeSlotsByPatient/', timeslotRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  SearchRemoteFacilitiesForAppointment(facilitysearchrequestModel: FacilitySearchRequestModel) {
    return this.post<ResultOfT<AppointmentFacilityResponseModel>>('Patient/SearchRemoteFacilitiesForAppointment', facilitysearchrequestModel).pipe(
      map((result) => {
        return result;
      })
    );
  }

  GetAppointmentById(AppointmentId: number) {
    return this.get<ResultOfT<AppointmentInfoReponseModel>>('Patient/GetAppointmentById/' + AppointmentId);
  }

  ScheduleAppointment(appointmentRequest: AppointmentRequestModel) {
    return this.post<ResultOfT<number>>('Patient/scheduleappointment/', appointmentRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  ReScheduleAppointment(appointmentRequest: AppointmentRequestModel) {
    return this.post<ResultOfT<number>>('Patient/ReScheduleAppointment/', appointmentRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  CancelAppointment(appointmentCancelRequest: AppointmentCancelRequest) {
    return this.post<ResultOfT<boolean>>('Patient/CancelAppointment/', appointmentCancelRequest).pipe(
      map((result) => {
        return result;
      })
    );
  }

  GetCancelFeesInfo(appointmentId) {
    return this.post<ResultOfT<CancelFeesInfo>>('Patient/GetCancelFeesInfo/', { appointmentId }).pipe(
      map((result) => {
        return result;
      })
    );
  }

  getPaymentSetting() {
    return this.get<ResultOfT<SettingsResponseModel>>('Patient/GetPaymentSetting');
  }

  getLastPaymentInfo(salesorderId: number): Observable<ResultOfT<PaymentTransaction>> {
    return this.get<ResultOfT<PaymentTransaction>>(`Patient/GetLastPaymentInfo/${salesorderId}`);
  }

  getWipStatusUpdateSetting() {
    return this.get<ResultOfT<SettingsResponseModel>>('Patient/GetWipStatusUpdateSetting'); 
  }
}
